@if (showLoader) {
  <div id="absolute-spinner">
    <div class="spinner-wrapper">
      <mat-spinner></mat-spinner>
    </div>
  </div>
}

@if (!showLoader) {
  <section
    class="home-page-wrapper home-page"
    fxFlex
    fxLayout="column"
    fxLayoutAlign="start center">
    @if (compassFeaturesEnabled) {
      <app-compass></app-compass>
    } @else {
      <div class="container-banner-home-header home-page__header">
        <div class="banner home-page__header-banner"
          [style.backgroundImage]="'url('+ imgBannerUrl +')'">
        </div>
        <div class="home-header home-page__header-content">
          @if (title && !titleTextInHomePageBanner) {
            <h1
              class="title home-page__header-title">
              <span>{{ title }}</span>
            </h1>
          }
          <div class="content home-page__header-text"
            [innerHTML]="content">
          </div>
        </div>
      </div>
    }
    @if (actualitiesFeaturesEnabled && (actualityWithoutCollectivity || actualityWithCollectivity)) {
      <section class="home-page__news">
        <h2 class="home-page__news-title">
          {{ 'generic.news' | translate }}
        </h2>
        <div class="home-page__news-content">
          @if (!!actualityWithoutCollectivity) {
            <app-actuality-card [actuality]="actualityWithoutCollectivity"
              (actionEmitter)="navigateToActuality(actualityWithoutCollectivity)">
            </app-actuality-card>
          }
          @if (!!actualityWithCollectivity) {
            <app-actuality-card [actuality]="actualityWithCollectivity" [isActualityWithCollectivity]="true"
              (actionEmitter)="navigateToActuality(actualityWithCollectivity)">
            </app-actuality-card>
          }
        </div>
      </section>
    }
    @if (showLoaderProgression && isProgressionEnable) {
      <div>
        <div class="spinner-wrapper">
          <mat-spinner></mat-spinner>
        </div>
      </div>
    }
    @if (!showLoaderProgression && isProgressionEnable && assignmentGroupedByClassesAndGroups.length) {
      <h1 class="resume-title">
        <span>{{'generic.home_resume' | translate}}</span>
      </h1>
      <div class="content-cards home-page__onboarding"
        fxLayout="row wrap">
        @for (dataCard of assignmentGroupedByClassesAndGroups; track dataCard) {
          <div class="home-page__onboarding-card-wrapper"
            fxFlex.gt-sm="49"
            fxFlex.gt-lg="32"
            fxFlex.lt-md="100"
            fxLayoutGap="10px"
            >
            <article class="home-page__onboarding-card">
              <header class="home-page__onboarding-header">
                <h2 class="home-page__onboarding-title">
                  <div class="home-page__onboarding-group">{{dataCard.group.groupname || dataCard.group.workgroupname}}</div>
                  <div class="home-page__onboarding-grade">{{'onboarding.program' | translate}} {{dataCard.group.level}}</div>
                </h2>
              </header>
              <div class="home-page__onboarding-content">
                <div class="home-page__onboarding-primary-content">
                  <div class="home-page__onboarding-progress">
                    <mat-progress-spinner class="home-page__onboarding-progress-spinner"
                      mode="determinate"
                      [value]="dataCard.progressionPercent">
                    </mat-progress-spinner>
                    <div class="home-page__onboarding-progress-percentage"
                      aria-hidden="true">
                      <span>{{ dataCard.progressionPercent }}&nbsp;%</span>
                    </div>
                  </div>
                  <div class="home-page__onboarding-lesson">
                    <div class="home-page__onboarding-lesson-period">
                      <span>First steps</span>
                    </div>
                    <div class="home-page__onboarding-lesson-sequence">
                      <span>Hello everyone!</span>
                    </div>
                  </div>
                  @if (isBtnProgressionCanBeDisplayed(dataCard)) {
                    <button class="home-page__onboarding-start-button"
                      data-e2e="home-page-open-progression"
                      [disabled]="!dataCard.enableProgression"
                      (click)="openProgression(dataCard)">
                      @if (dataCard.allAssignmentsCollectiveInClasse?.length > 0) {
                        <span>{{'onboarding.resume' | translate}}</span>
                      } @else  {
                        <span>{{'onboarding.start' | translate}}</span>
                      }
                      <mat-icon svgIcon="home-page__onboarding-play"></mat-icon>
                    </button>
                  }
                </div>
                <button class="home-page__onboarding-search-button"
                  data-e2e="home-page-go-to-search-lessons"
                  (click)="goToSearchLessons(dataCard)">
                  <mat-icon class="home-page__onboarding-search-icon"
                    svgIcon="home-page__onboarding-search">
                  </mat-icon>
                  <div class="home-page__onboarding-search-label">
                    <span>{{'onboarding.find_lesson' | translate}} {{dataCard.group.groupname}}</span>
                  </div>
                </button>
              </div>
            </article>
          </div>
        }
      </div>
      <h1 class="discover-title">
        <span>{{'generic.home_discover' | translate}}</span>
      </h1>
    }
    @if (showCollection) {
      @if (showCollectionTitle) {
        <h2
          class="home-page__collection-title">
          {{ 'generic.home_collection_title' | translate}}
        </h2>
      }
      <div class="content-cards data-cards home-page__collections"
        fxLayout="row wrap">
        @for (dataCard of dataCards; track dataCard) {
          <div
            class="home-page__collection-card-wrapper"
            fxFlex.gt-sm="49"
            fxFlex.gt-lg="32"
            fxFlex.lt-md="100">
            <mat-card fxLayout="column"
              class="home-page__collection-card">
              <mat-card-header class="home-page__collection-card-header">
                <mat-card-title>
                  @if (dataCard?.image?.uri) {
                    <span
                      class="image-title home-page__collection-card-image"
                      [style.backgroundImage]="'url('+ dataCard?.image?.uri +')'">
                    </span>
                  }
                  <h3 class="mat-mdc-card-title-text home-page__collection-card-title"
                    [ngClass]="dataCard?.image?.uri ? 'image' : 'no-image'">
                    {{ dataCard?.title }}
                  </h3>
                </mat-card-title>
              </mat-card-header>
              <div class="wrapper-content home-page__collection-card-content-wrapper"
                fxLayout="column"
                fxLayoutAlign="space-between start">
                <mat-card-content class="home-page__collection-card-content">
                  <div fxFlex
                    fxLayout="row"
                    fxLayoutAlign="start start">
                    <dl class="dl-listitem-inline"
                      role="list">
                      <ng-container>
                        <!-- <dt>{{'generic.goals' | translate}}</dt> -->
                        <dd [innerHTML]="dataCard?.description?.value"></dd>
                      </ng-container>
                    </dl>
                  </div>
                </mat-card-content>
                <mat-card-actions class="home-page__collection-card-actions"
                  fxFlex
                  fxLayout="row"
                  fxLayoutAlign="end start">
                  @if (dataCard.link_label && dataCard.link_label !== '') {
                    <button
                      class="button-play home-page__collection-card-button"
                      data-e2e="home-page-play-collection"
                      (click)="play(dataCard)"
                      role="button">
                      <span>{{ dataCard.link_label }}</span>
                    </button>
                  }
                </mat-card-actions>
              </div>
            </mat-card>
          </div>
        }
      </div>
    }
  </section>
}
